import { Sun, Moon } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import './preference-switches.css';

export function ThemeToggle({ className }: { className?: string }) {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation();
  return <button className={cn('theme-switch', className)} role="switch" aria-checked={theme === 'dark'} aria-label={t('nav.darkMode')} onClick={toggleTheme}>
    <span className="theme-switch-thumb" data-dark={theme === 'dark'} />
    <Sun size={14} aria-hidden="true" /><Moon size={14} aria-hidden="true" />
  </button>;
}
export default ThemeToggle;
